import {cookieToken} from './url'
export const driveconfig = {
  headers: { 'x-access-token': cookieToken }
};
